import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { url, ipRoot } from './bodyAll'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  apiUrl = url;
  _user: any;

  constructor(
    private http: HttpClient,
    private httpP: HTTP
    ) { }

  loginOld (data): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'b_users/login', data)//'signin'
      .pipe(
        tap(_ => this.log('login')),
        // tap(_ => _.json()),
        catchError(this.handleError('login', []))
      );
  }

  /* register (data): Observable<any> {
    let seq = this.http.post(this.apiUrl + 'singup', data);//  'login'
    return seq;  
  } */
  login(accountInfo: any): Observable<any>{
    let seq = this.http.post(this.apiUrl + 'b_users/login', accountInfo);//  'login'
    return seq; 
  }
  login2(accountInfo: any) {
    // this.httpP.setDataSerializer('json');
    let seq = this.httpP.post(this.apiUrl + 'b_users/login', accountInfo, null);//  'login'

    seq.then((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status == 'success') {
        this._user = res.user;
        //return res.json();
      }  
    }, err => {
      this.handleError('login', []);
      console.error('ERROR', err);
    });

    return seq;
  }


  logout (): Observable<any> {          //    NO SE USA
    return this.http.get<any>(this.apiUrl + 'b_users/logout?access_token=' + localStorage.getItem('TOKEN'))
      .pipe(
        tap(_ => this.log('logout')),
        catchError(this.handleError('logout', []))
      );
  }

  register (data): Observable<any>  {
    let seq = this.http.post(this.apiUrl + 'b_users', data);//  'login'
    return seq; 
    /* this.httpP.setDataSerializer('json');
    const seq = this.httpP.post(this.apiUrl + 'b_users', data, null);
    seq.then((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.status == 'success') {
        this._user = res.user;
        return res.json();
      }  
    }, err => {
      this.handleError('login', []);
      console.error('ERROR', err);
    });

    return seq; */  
  }
  /**
   * Acces with coinbase
   * @param data 
   * @returns 
   */

  getClienteCoinbase(data){
    let seq = this.http.post(this.apiUrl + 'coinbase/client_coinbase', data);//  'login'
    return seq; 
    
  }
  refreshClienteCoinbase(data){
    let seq = this.http.post(this.apiUrl + 'coinbase/update_client_coinbase', data);//  'login'
    return seq; 
  }
  
  /**
   * acceses with Metamask
   * @returns 
   */
  connectMetamask(data){
    let seq = this.http.post(this.apiUrl + 'metamask', data);//  'login'
    return seq; 
  }
  disconnectMetamask(data){
    let seq = this.http.delete(this.apiUrl + 'metamask', data);//  'login'
    return seq; 
  }

  getTerminosCondiciones(){
    let seq = this.http.get(this.apiUrl + 'findTerminosCondiciones/user');//  'login'
    return seq;  
  }

  recoveryUser(data){
    let seq = this.http.post(this.apiUrl + 'b_users/reset', data, this.header_config());//  'login'
    return seq;
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(message);
  }

  public header_config (){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return httpOptions;
  };
  
}

export var ip = ipRoot
export const url_upload_profile = url+'uploads/usr';
export const url_upload_licences = url+'uploads/usr';
export const url_upload_voices = url+'uploads/usr';
export const url_download_voices = url+'downloads/prod/';
export const url_download = url+'downloads/prod/';
export const url_api_instapago = 'https://api.instapago.com/payment';
